import { defineStore } from 'pinia'
import { store } from '../index'
import { GetWorkShift } from '@/api/oee'
import { GetNodesByGroup, GetGroupByProject } from '@/api/apm'
import { GetSystemSetting } from '@/api/mu'
import { Utc2Localtime, ConvertShiftTime } from '@/utils'
import { InitTreeNodeList } from '@/utils/tree'
import { SYSTEM_SETTING_TYPE } from '@/config/global'

export const usePmsStore = defineStore({
  id: 'Pms',
  state: () => ({
    service:'',
    servicekey:'',
    assetId:null as any,
    assetName:'',
    assetList: [] as any,
    assetLevel: 0,
    statusNames: null as any,
    assetLayerNames: null as any,
    shiftInfo: null as any,
    rawShiftInfo: '',    
    ruleInfo: null as any,
    allNodeList: null as any,
    treeData: null as any,
    devList: null as any
  }),
  getters: {
    getService(): any {
      return this.service
    }, 
    getServiceKey(): any {
      return this.servicekey
    },       
    getAssetId(): any {
      return this.assetId
    },    
    getAssetName(): any {
      return this.assetName
    },
    getAssetList(): any {
      return this.assetList
    },
    getAssetLevel(): any {
      return this.assetLevel
    },
    getStatusNames(): any {
      return this.statusNames
    }, 
    getLayerNames(): any {
      return this.assetLayerNames
    },       
    getShiftInfo(): any {
      return this.shiftInfo
    },
    getRawShiftInfo(): any {
      return JSON.parse(this.rawShiftInfo) 
    },
    getTreeData(): any {
      return this.treeData
    },        
    getAllNodeList(): any {
      return this.allNodeList
    }
  },
  actions: {
    setService(){
      this.servicekey = this.service = 'PMS'
      const service = window.$wujie?.props?.service
      const servicekey = window.$wujie?.props?.currentAppService
      if(service){
        this.service = service
      }
      if(servicekey){
        this.servicekey = servicekey
      }
      // this.servicekey = "internal-vRMIJFYe-1740627231735661388"      
    },
    async InitAssetList() {
      if(window.$wujie){
        try{
          const wujieConfig = window.$wujie?.props?.dataSourceInfo
          if(wujieConfig){
            const type = wujieConfig.type  //"group" {name: '水冷能源站', id: 56} "project" {name: 'MU', id: 2}
            const value = wujieConfig.value
            let isGroup = false
            let isProject = false
            if(Array.isArray(type)){
              isGroup = type.includes("group")
              isProject = type.includes("project")
            }else{
              isGroup = (type=="group")
              isProject = (type=="project")
            }
            if(!isGroup && !isProject){
              return
            }            
            if(!value || value.length==0){
              return
            }
            if(isGroup){
              this.assetList = [...value]
            }else if(isProject){
              const params = {
                projectName:value.map(item=>item.name),
                gteGrade:2,
                count:1000
              }
              const res = await GetGroupByProject(params)
              if(!res || !res.e || res.e.length==0){
                return
              }
              this.assetList = res.e.map(item=>{
                return {
                  id:item.id,
                  name:item.name
                }
              })
            }
          } 
        }catch(error){
          console.log(error)
          return
        }       
      }else{
        const params = {
          gteGrade:2,
          count:1000
        }        
        const res = await GetGroupByProject(params)
        if(!res || !res.e || res.e.length==0){
          return
        }
        this.assetList = res.e.map(item=>{
          return {
            id:item.id,
            name:item.name
          }
        })
      }
    },
    async getConfigNames() {
      const ASSET_ID = SYSTEM_SETTING_TYPE.ASSET_ID +this.servicekey
      const RUN_STATUS = SYSTEM_SETTING_TYPE.RUN_STATUS +this.servicekey
      const ASSET_LAYER_NAME = SYSTEM_SETTING_TYPE.ASSET_LAYER_NAME +this.servicekey
      const params = {
        type: [
          ASSET_ID,
          RUN_STATUS,
          ASSET_LAYER_NAME
        ]
      } 
      const res = await GetSystemSetting(params)
      if(res && res.errorCode==0){
        const idObj = res.setting.find(item=>item.type==ASSET_ID)
        if(idObj?.setting){
          this.assetId = Number(idObj.setting) 
        }        
        const statusObj = res.setting.find(item=>item.type==RUN_STATUS)
        if(statusObj){
          this.statusNames = statusObj.setting
        }  
        const layerObj = res.setting.find(item=>item.type==ASSET_LAYER_NAME)
        if(layerObj){
          this.assetLayerNames = layerObj.setting
        }           
      }
      console.log('++getConfigNames',this.statusNames,this.assetLayerNames)      
    },     
    setShift(payload: any) {
      this.shiftInfo = payload
    },
    async getShift() {        
        let shiftInfo = {
            today:{
              from:null,
              to:null,
              day:{
                from:null,
                to:null
              },
              night:{
                from:null,
                to:null
              }
            },
            yesterday:{
              from:null,
              to:null,
              day:{
                from:null,
                to:null
              },
              night:{
                from:null,
                to:null
              }
            }
          }
        if(this.assetId){
          const params = {
            groupId: this.assetId
          }
          const res = await GetWorkShift(params)
          if(res && res.errorCode==0 && res.result){
              const data = JSON.parse(res.result) 
              this.rawShiftInfo = res.result
              shiftInfo = ConvertShiftTime(data,new Date())          
          } 
          this.shiftInfo = shiftInfo   
          return res         
        }
    },    
    async getPmsTreeData(resetFlag:any=false) {
      if(!resetFlag && this.allNodeList){
        return this.treeData
      }
      if(!this.assetId) return
      const assetObj = this.assetList.find(item=>item.id==this.assetId)
      if(assetObj){
        const {tree,allNodeList,devList,level} = await InitTreeNodeList(assetObj.id)
        this.allNodeList = allNodeList
        this.treeData = tree
        this.assetLevel = level
        return tree        
      }
    },
    clearTreeData(){
      this.allNodeList = null
      this.treeData = null
      this.devList = null
      this.assetLevel = 0
    }
  }
})

export const usePmsStoreWithOut = () => {
  return usePmsStore(store)
}
